import { getType } from 'typesafe-actions';

import { CanvasEditorAction } from '../common/actions';

import { closeItemNameEditor, openItemNameEditor, updateItemNameEditorValue } from './actions';
import { ItemNameEditorsState, ItemNameEditorState } from './typings';

export const getDefaultItemNameEditorState = (): ItemNameEditorState => {
    return {
        value: '',
        isVisible: false
    };
};

export function itemNameEditors(state: ItemNameEditorsState = {}, action: CanvasEditorAction): ItemNameEditorsState {
    switch (action.type) {
        case getType(openItemNameEditor): {
            const editorId = action.editorId;
            const editorState = state[editorId] || getDefaultItemNameEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    value: action.value,
                    isVisible: true
                }
            };
        }

        case getType(closeItemNameEditor): {
            const editorId = action.editorId;

            return {
                ...state,
                [editorId]: getDefaultItemNameEditorState()
            };
        }

        case getType(updateItemNameEditorValue): {
            const editorId = action.editorId;
            const editorState = state[editorId] || getDefaultItemNameEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    value: action.value
                }
            };
        }

        default:
            return state;
    }
}
